!(function () {
    ("use strict");

    class MySizeGuide extends HTMLElement {

        constructor() {
            super();
            this.body = document.querySelector('body')
            this.container = this.querySelector("[data-size-guide-container]")
            this.button = this.container.querySelector("button")
            this.buttonClose = this.container.querySelector(".product-quick-view__close")
            this.modal = this.container.querySelector("dialog")
            this.tableContainer = this.container.querySelector(".slider__wrapper")
            this.table = this.tableContainer.querySelector("&>div")
            this.slider = this.container.querySelector(".slider__container")
            this.prev = this.slider.querySelector(".slider__button__top");
            this.next = this.slider.querySelector(".slider__button__bottom");
        }

        connectedCallback() {
            this.handleEvents();
            this.createSlider();
        }

        onBodyClick(event) {
            if (event.target.matches("dialog")) {
                this.closeModal()
            }
        }

        handleEvents() {
            this.button.addEventListener("click", () => {
                this.openModal()
            });
            this.buttonClose.addEventListener("click", () => {
                this.closeModal()
            });
        }

        openModal() {
            this.modal.showModal();
            this.body.classList.add('lock-scroll');
            document.body.addEventListener("click", this.onBodyClick.bind(this));
        }

        closeModal() { 
            this.modal.classList.add('is-closing');
            setTimeout(() => {
                this.modal.classList.remove('is-closing');
                this.modal.close()
                this.body.classList.remove('lock-scroll');
            }, 500);
        }

        createSlider() {
            if (this.slider) {
                this.prev.addEventListener("click", () => {
                    this.scrollLeft();
                });

                this.next.addEventListener("click", () => {
                    this.scrollRight();
                });
            }
        }

        scrollLeft() {
            this.tableContainer.scrollTo({
                left: this.tableContainer.scrollLeft - this.table.firstElementChild.offsetWidth,
                behavior: "smooth"
            });
        }

        scrollRight() {
            this.tableContainer.scrollTo({
                left: this.tableContainer.scrollLeft + this.table.firstElementChild.offsetWidth,
                behavior: "smooth"
            });
        }
    }

    customElements.define("size-guide", MySizeGuide);
})();